import React from "react";
import {
  Create,
  SimpleForm,
  translate,
  CardActions,
  ListButton,
  TextInput,
  NumberInput
} from "react-admin";

import YandexMapPolygon from "../components/map/YandexMapPolygon";

import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";

const validate = translate => values => {
  const errors = {};

  return errors;
};

const styles = theme => ({});

// const DistrictTitle = ({ record }) =>  record && record.name ? record.name : null;

const DistrictActions = ({ basePath }) => (
  <CardActions>
    <ListButton basePath={basePath} />
  </CardActions>
);

const DistrictCreate = ({ classes, ...props }) => {
  const { translate } = props;

  return (
    <Create
      {...props}
      classes={{ card: classes.card }}
      actions={<DistrictActions />}
    >
      <SimpleForm validate={validate(translate)}>
        <TextInput source="name" />
        <NumberInput source="id_cian" />
        <YandexMapPolygon source="geo_coordinates" />
      </SimpleForm>
    </Create>
  );
};

export default compose(
  withStyles(styles),
  translate
)(DistrictCreate);
